"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
const NeutralPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _react.default.createElement("path", {
  d: "M15 7V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7Z"
}), _react.default.createElement("path", {
  d: "M7.49289 8.90711L8.89289 10.3071C9.28342 10.6976 9.91658 10.6976 10.3071 10.3071C10.6976 9.91658 10.6976 9.28342 10.3071 8.89289L8.90711 7.49289C8.51658 7.10237 7.88342 7.10237 7.49289 7.49289C7.10237 7.88342 7.10237 8.51658 7.49289 8.90711Z"
}), _react.default.createElement("path", {
  d: "M5 17H7C7.55228 17 8 16.5523 8 16C8 15.4477 7.55228 15 7 15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17Z"
}), _react.default.createElement("path", {
  d: "M23.0929 7.49289L21.6929 8.89289C21.3024 9.28342 21.3024 9.91658 21.6929 10.3071C22.0834 10.6976 22.7166 10.6976 23.1071 10.3071L24.5071 8.90711C24.8976 8.51658 24.8976 7.88342 24.5071 7.49289C24.1166 7.10237 23.4834 7.10237 23.0929 7.49289Z"
}), _react.default.createElement("path", {
  d: "M25 15H27C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H25C24.4477 17 24 16.5523 24 16C24 15.4477 24.4477 15 25 15Z"
}), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 16C9 12.1477 12.1477 9 16 9C19.8523 9 23 12.1477 23 16C23 18.7117 21.4028 21.1397 19 22.3479V24C19 24.5523 18.5523 25 18 25H14C13.4477 25 13 24.5523 13 24V22.3479C10.5972 21.1397 9 18.7117 9 16ZM17 21.7C17 21.2884 17.2523 20.9188 17.6356 20.7688C19.64 19.9844 21 18.0995 21 16C21 13.2523 18.7477 11 16 11C13.2523 11 11 13.2523 11 16C11 18.0995 12.36 19.9844 14.3644 20.7688C14.7477 20.9188 15 21.2884 15 21.7V23H17V21.7Z"
}), _react.default.createElement("path", {
  d: "M19 27C19 27.5523 18.5523 28 18 28H14C13.4477 28 13 27.5523 13 27C13 26.4477 13.4477 26 14 26H18C18.5523 26 19 26.4477 19 27Z"
}));
const NeutralMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  fill: "currentColor"
}, _react.default.createElement("circle", {
  cx: "12",
  cy: "18",
  r: "3",
  "data-color": "color-2"
}), _react.default.createElement("path", {
  d: "M12 9a8.94 8.94 0 00-6.364 2.636l-.707.707 1.414 1.414.707-.707C8.373 11.728 10.13 11 12 11s3.627.728 4.95 2.05l.707.707 1.414-1.414-.707-.707A8.94 8.94 0 0012 9z"
}), _react.default.createElement("path", {
  d: "M22.606 7.394C19.774 4.561 16.007 3 12 3S4.226 4.561 1.394 7.394l-.707.707 1.414 1.414.707-.707C5.263 6.352 8.527 5 12 5s6.737 1.352 9.192 3.808l.707.707 1.414-1.414-.707-.707z"
})));
const AbstractNeutral = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(NeutralMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(NeutralPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractNeutral);